/**
 * A `StringSearchFieldValueTag` component renders a rectangular text
 * tag element with a light-blue background and a "x" FontIcon to the right
 * to represent one of the string search values chosen by the user. Notice
 * that this component is used only for UI rendering so it should not contain
 * any custom state logic of its own
 */

import React from 'react';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import * as Colors from 'material-ui/styles/colors';

const iconButtonStyle = {
  padding: '0',
  marginRight: '5px',
  float: 'right',
  width: '28px',
  height: '28px',
};

class StringSearchFieldValueTag extends React.Component {
  onTouchTapIconButton() {
    this.props.onTouchTapValueTagRemoveButton(this.props.value);
  }

  render() {
    return (
      <div className="string-search-field-value-tag">
        <span className="value">{this.props.value}</span>
        <IconButton style={iconButtonStyle} onClick={this.onTouchTapIconButton.bind(this)}>
          <FontIcon className="material-icons font-icon" color={Colors.grey400}>
            close
          </FontIcon>
        </IconButton>
      </div>
    );
  }
}

export default StringSearchFieldValueTag;
